module.exports = __webpack_public_path__ + "static/img/公众号.c9f529f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/公众号.jpg
// module id = UXsY
// module chunks = 14